<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
      <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
      <img fxHide.lt-md fxFlex="0 0 36px" height="36px" src="/assets/images/apps/integrations/autohost.jpg" />
      <span fxFlex>Autohost</span>
    </h2>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'apps-autohost'"></sbnb-helptext-wrapper>

    <ng-container>
      <mat-spinner *ngIf="loading" [diameter]="30"></mat-spinner>

      <div fxLayout fxLayout.lt-md="column" fxLayoutGap="40px">
        <div fxFlex>
          <h3>API Keys</h3>
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <div
              *ngIf="!showInput"
              fxFlex
              fxLayout
              fxLayoutAlign="start center"
              class="api-keys"
              [ngClass.lt-md]="'fullwidth'"
              fxFlex.lt-md="48px">
              <span fxFlex>
                <strong>Connected Api Key -</strong>
                {{ apiKey }}
              </span>

              <span id="delete_api_key_button" class="grass-darker" (click)="removeApiKey()">
                {{ apiKeyDeleting ? 'Deleting...' : 'Delete' }}
              </span>
            </div>
          </div>

          <div *ngIf="showInput" class="input__container" fxLayoutGap="12px">
            <mat-form-field fxFlex>
              <input [(ngModel)]="apiKey" matInput placeholder="Enter your API key" (keydown.enter)="saveApiKey()" />
            </mat-form-field>
          </div>

          <div *ngIf="showInput" class="input__container" fxLayoutGap="12px">
            <button fxFlex="100px" type="submit" mat-flat-button (click)="saveApiKey()">Save</button>
          </div>
        </div>
      </div>
    </ng-container>

    <div fxLayout fxLayoutAlign="end center">
      <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>
  </main>
</div>
